import { JstDate } from '../../core/time/business-time';
import { Component, OnInit, inject } from '@angular/core';
import { Router, RouterLink, ActivatedRoute } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { PageTitleService } from '../../core/services/page-title.service';
import { StudioService } from '../../core/services/studio.service';
import { FlashService } from '../../core/services/flash.service';
import { FlashMessageComponent } from '../../shared/components/flash-message.component';

@Component({
    selector: 'app-studio-plan-edit',
    imports: [RouterLink, FormsModule, FlashMessageComponent],
    template: `
<div class="animated fadeIn">
  <div class="row sfapp-container">
    <div class="col-md-12">
      <div class="card">
        <div class="card-header">
          <span><i class="fa s-icon-edit"></i>&nbsp;区分コース 編集</span>
        </div>
        <div class="card-body">
          <!-- 旧版 studioPlan-edit.html:10-12 の card-body 先頭 <flash-message> 相当 -->
          <div class="col-md-12"><app-flash-message></app-flash-message></div>
          <div class="col-md-12">
            @if (loading) {
              <div class="text-center py-3"><span class="fa fa-spinner fa-spin fa-2x"></span></div>
            }
            @if (!loading) {
              <div class="form-group row">
                <div class="col-md-6">
                  <table class="table-bordered table-sm">
                    <thead>
                      <tr><th width="50%">表示ID</th><th width="50%">店舗名</th></tr>
                    </thead>
                    <tbody>
                      <tr><td>{{studio.sortBy}}</td><td>{{studio.name}}</td></tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <form novalidate name="studioPlanEditForm" #studioPlanEditForm="ngForm" (ngSubmit)="save()">
                <div class="form-group row">
                    <div class="col-md-6">
                      <label class="col-form-label">コース名</label>
                      <input type="text" class="form-control" [(ngModel)]="form.name" name="name" required maxlength="200">
                    </div>
                  </div>
                <div class="form-group row">
                    <div class="col-md-6">
                      <label class="col-form-label">コースタイプ</label>
                      <select class="form-control" [(ngModel)]="form.studioPlanTypeId" name="studioPlanTypeId">
                        <option value="">-- なし --</option>
                        @for (t of planTypes; track t.id) {
                          <option [value]="t.id">{{t.name}}</option>
                        }
                      </select>
                    </div>
                  </div>
                <div class="row">
                    <div class="form-group col-md-4">
                      <label class="col-form-label">利用時間</label>
                      <select class="form-control" [(ngModel)]="form.time" name="time" required>
                        <option value="">-- 選択してください --</option>
                        <option value="24">24時間</option>
                        <option value="0">その他</option>
                      </select>
                    </div>
                    @if (form.time == '0') {
                      <div class="form-group col-md-4">
                        <label class="col-form-label">時間を選択してください</label>
                        <div class="bisected-input-wrap">
                          <div class="bisected-input">
                            <select class="form-control" [(ngModel)]="form.time_start" name="time_start" required>
                              @for (t of timeOptions; track t.id) {
                                <option [value]="t.id">{{t.name}}</option>
                              }
                            </select>
                          </div>
                          <span>&nbsp;~&nbsp;</span>
                          <div class="bisected-input">
                            <select class="form-control" [(ngModel)]="form.time_end" name="time_end" required>
                              @for (t of timeOptions; track t.id) {
                                <option [value]="t.id">{{t.name}}</option>
                              }
                            </select>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                <div class="form-group row">
                    <div class="col-md-6">
                      <label class="col-form-label">月会費（初月）</label>
                      <select class="form-control" [(ngModel)]="form.firstMonthProductId" name="firstMonthProductId" required>
                        <option value="">-- 選択してください --</option>
                        @for (p of products1; track p.id) {
                          <option [value]="p.id">{{productLabel(p)}}</option>
                        }
                      </select>
                    </div>
                  </div>
                <div class="form-group row">
                    <div class="col-md-6">
                      <label class="col-form-label">月会費（2ヶ月目）</label>
                      <select class="form-control" [(ngModel)]="form.secondMonthProductId" name="secondMonthProductId" required>
                        <option value="">-- 選択してください --</option>
                        @for (p of products1; track p.id) {
                          <option [value]="p.id">{{productLabel(p)}}</option>
                        }
                      </select>
                    </div>
                  </div>
                <div>
                    <label class="col-form-label">月会費（3~12ヶ月目）</label>
                    <a href="" class="btn btn-success" [class.disabled]="sortLength > 9" (click)="pushIndividuals(); $event.preventDefault()"><i class="fa fa-plus-circle"></i></a>
                    <a href="" class="btn btn-success" [class.disabled]="sortLength < 1" (click)="popIndividuals(); $event.preventDefault()"><i class="fa fa-minus-circle"></i></a>
                  </div>
                @for (item of visibleIndividuals(); track $index) {
                  <div class="form-group row">
                      <div class="col-md-6">
                        <label class="col-form-label">{{$index + 3}}ヶ月目</label>
                        <select class="form-control" [(ngModel)]="item.productId" [name]="'ind_' + $index" required>
                          <option value="">-- 選択してください --</option>
                          @for (p of products1; track p.id) {
                            <option [value]="p.id">{{productLabel(p)}}</option>
                          }
                        </select>
                      </div>
                  </div>
                }
                <div class="form-group row">
                    <div class="col-md-6">
                      <label class="col-form-label">月会費（通常）</label>
                      <select class="form-control" [(ngModel)]="form.monthlyProductId" name="monthlyProductId" required>
                        <option value="">-- 選択してください --</option>
                        @for (p of products1; track p.id) {
                          <option [value]="p.id">{{productLabel(p)}}</option>
                        }
                      </select>
                    </div>
                  </div>
                <div class="form-group row">
                    <div class="col-md-6">
                      <label class="col-form-label">入会金・事務手数料</label>
                      <select class="form-control" [(ngModel)]="form.studioKeyProductId" name="studioKeyProductId" required>
                        <option value="">-- 選択してください --</option>
                        @for (p of products2; track p.id) {
                          <option [value]="p.id">{{productLabel(p)}}</option>
                        }
                      </select>
                    </div>
                  </div>
                <div class="form-group row">
                    <div class="col-md-12 text-right">
                      <a [routerLink]="['/studio', studioId, 'plan']" class="btn bg-close text-white"><i class="fa s-icon-cancel"></i>&nbsp;閉じる</a>
                      <button type="submit" class="btn btn-success" [disabled]="saving || studioPlanEditForm.invalid"><i class="fa s-icon-save"></i>&nbsp;保存</button>
                    </div>
                </div>
              </form>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
  `
})
export class StudioPlanEditComponent implements OnInit {
  private pageTitleService = inject(PageTitleService);
  private studioService = inject(StudioService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private flash = inject(FlashService);

  studioId!: number;
  planId!: number;
  studio: any = {};
  form: any = {};
  products: any[] = [];
  planTypes: any[] = [];
  sortLength = 0;
  loading = true;
  saving = false;

  readonly timeOptions = Array.from({ length: 24 }, (_, i) => ({
    id: i,
    name: String(i).padStart(2, '0') + ':00',
  }));

  get products1() { return this.products.filter(p => p.productType === 1); }
  get products2() { return this.products.filter(p => p.productType === 2); }

  async ngOnInit(): Promise<void> {
    this.pageTitleService.set('店舗管理', 's-icon-studio');
    const hasStudioIdParam = this.route.snapshot.paramMap.has('studioId');
    this.studioId = +this.route.snapshot.params['studioId'];
    this.planId = +this.route.snapshot.params['planId'];
    try {
      const [plan, planTypes]: any[] = await Promise.all([
        this.studioService.getStudioPlan(this.planId),
        this.studioService.getPlanType(),
      ]);
      this.form = plan ?? { id: this.planId };
      this.planTypes = Array.isArray(planTypes) ? planTypes : [];
      this.sortLength = this.form.studioPlanIndividuals?.length ?? 0;
      this.form.freeKeyOption = String(this.form.freeKeyOption ?? '');
      if (this.form.time === '24時間') {
        this.form.time = '24';
        this.form.time_start = 0;
        this.form.time_end = 0;
      } else if (this.form.time) {
        this.form.time_start = Number(this.form.time.slice(0, 2));
        this.form.time_end = Number(this.form.time.slice(6, 8));
        this.form.time = '0';
      }
      const studioIdFromPlan = this.form.studioId ?? this.studioId;
      if (!Number.isFinite(this.studioId)) this.studioId = Number(studioIdFromPlan);
      if (!hasStudioIdParam && Number.isFinite(this.studioId)) {
        await this.router.navigate(['/studio', this.studioId, 'plan', this.planId, 'edit'], { replaceUrl: true });
        return;
      }
      const [studio, productData]: any[] = await Promise.all([
        this.studioService.list(studioIdFromPlan),
        this.studioService.getProduct(studioIdFromPlan),
      ]);
      this.studio = studio;
      this.products = (Array.isArray(productData) ? productData : []).filter((p: any) => p.status === 0);
    } finally {
      this.loading = false;
    }
  }

  productLabel(p: any): string {
    const price = Math.floor(p.amount * (1 + Number(p.taxRate?.rate ?? 0)));
    return `(¥${price.toLocaleString()}) ${p.name}`;
  }

  visibleIndividuals(): any[] {
    return (this.form.studioPlanIndividuals ?? []).filter((v: any) => v.sortBy <= this.sortLength);
  }

  pushIndividuals(): void {
    if (!this.form.studioPlanIndividuals) this.form.studioPlanIndividuals = [];
    if (this.sortLength >= 10) return;
    if (this.sortLength >= this.form.studioPlanIndividuals.length) {
      this.form.studioPlanIndividuals.push({
        studioPlanId: this.form.id,
        productId: null,
        sortBy: this.form.studioPlanIndividuals.length + 1,
      });
    }
    this.sortLength += 1;
  }

  popIndividuals(): void {
    if (this.sortLength > 0) this.sortLength--;
  }

  async save(): Promise<void> {
    if (!this.form?.name) return;
    this.saving = true;
    try {
      const json = { ...this.form };
      const findProduct = (id: any) => this.products.find(p => p.id == id);
      json.firstMonthFee = findProduct(json.firstMonthProductId)?.amount;
      json.secondMonthFee = findProduct(json.secondMonthProductId)?.amount;
      json.monthlyFee = findProduct(json.monthlyProductId)?.amount;
      if (json.time === '24') {
        json.time = '24時間';
      } else {
        const pad = (n: number) => String(n).padStart(2, '0') + ':00';
        json.time = `${pad(json.time_start)}〜${pad(json.time_end)}`;
      }
      delete json.time_start;
      delete json.time_end;
      const individuals = (this.form.studioPlanIndividuals ?? [])
        .filter((v: any) => v.sortBy <= this.sortLength || (v.sortBy > this.sortLength && v.id));
      individuals.forEach((v: any) => {
        if (v.sortBy > this.sortLength) v.deletedAt = new JstDate();
      });
      json.studioPlanIndividuals = individuals;
      json.studioId = this.studioId;
      await this.studioService.upsertStudioPlan(json);
      window.scrollTo({ top: 0 });
      // 旧版 studio.js:877-878: 先頭へscroll・Flash
      this.flash.create('success', '区分コースを更新しました');
      this.loading = true;
      await this.ngOnInit();
    } finally {
      this.saving = false;
    }
  }
}
